<template>
	<van-tabbar v-if="show" v-model="active" active-color="#f07178" :border="false" inactive-color="#f07178"
		z-index="999" class="app-tabbar">
		<!-- 首页 -->
		<van-tabbar-item to="/Home">
			<span>{{ $t("foorter.index") }}</span>
			<template #icon="props">
				<img :src="props.active ? '/img/footer/indexed.png' : '/img/footer/index.png'"
					:alt="$t('foorter.index')" v-show="show !== 0" />
				<img :src="props.active ? '/img/footer/indexed.png' : '/img/footer/index.png'"
					:alt="$t('foorter.index')" :class="$t('foorter.index')" style="height: 4rem" v-show="show === 0" />
			</template>
		</van-tabbar-item>
		
		<!-- 游戏 -->
		<van-tabbar-item to="/game">
			<span>{{ $t("foorter.video") }}</span>
			<template #icon="props">
				<img :src="props.active ? '/img/footer/toupiaoed.png' : '/img/footer/toupiao.png'"
					:alt="$t('foorter.video')" v-show="show !== 3" />
				<img :src="props.active ? '/img/footer/toupiaoed.png' : '/img/footer/toupiao.png'"
					:alt="$t('foorter.video')" :class="$t('foorter.video')" style="height: 4rem" v-show="show === 3" />
			</template>
		</van-tabbar-item>

		<!-- 中心：选妃 / Choose -->
		<van-tabbar-item to="/Choose" class="tab-center">
			<span>{{ $t("foorter.xuanfei") }}</span>
			<template #icon="props">
				<img class="tui" :src="props.active ? '/img/footer/xuanfeied.png' : '/img/footer/xuanfei.png'"
					:alt="$t('foorter.xuanfei')" v-show="show !== 2" />
				<img class="tui" :src="props.active ? '/img/footer/xuanfeied.png' : '/img/footer/xuanfei.png'"
					:alt="$t('foorter.xuanfei')" :class="$t('foorter.xuanfei')"
					v-show="show === 2" />
			</template>
		</van-tabbar-item>
		
		
		<!-- 影院 -->
		<van-tabbar-item to="/Video">
			<span>{{ $t("foorter.subscribe") }} </span>
			<template #icon="props">
				<img :src="props.active ? '/img/footer/yingyuaned.png' : '/img/footer/yingyuan.png'"
					:alt="$t('foorter.subscribe')" v-show="show !== 1" />
				<img :src="props.active ? '/img/footer/yingyuaned.png' : '/img/footer/yingyuan.png'"
					:alt="$t('foorter.subscribe')" :class="$t('foorter.subscribe')" style="height: 4rem"
					v-show="show === 1" />
			</template>
		</van-tabbar-item>
		
		
		<!-- 我的 -->
		<van-tabbar-item to="/Mine">
			<span>{{ $t("foorter.my") }}</span>
			<template #icon="props">
				<img :src="props.active ? '/img/footer/myed.png' : '/img/footer/my.png'" :alt="$t('foorter.my')"
					v-show="show !== 4" />
				<img :src="props.active ? '/img/footer/myed.png' : '/img/footer/my.png'" :alt="$t('foorter.my')"
					:class="$t('foorter.my')" style="height: 4rem" v-show="show === 4" />
			</template>
		</van-tabbar-item>
		
	</van-tabbar>
	
</template>

<script>
	export default {
		data() {
			return {
				show: false,
				active: 0
			};
		},
		methods: {},
		watch: {
			$route(to) {
				if (to.name == "home") {
					this.active = 0;
					this.show = true;
				} else if (to.name == "video") {
					this.active = 3;
					this.show = true;
				} else if (to.name == "choose") {
					this.active = 2;
					this.show = true;
				} else if (to.name == "game") {
					this.active = 1;
					this.show = true;
				} else if (to.name == "mine") {
					this.active = 4;
					this.show = true;
				} else {
					this.show = false;
				}
			},
		},
		created() {
			if (this.$route.name == "home") {
				this.active = 0;
				this.show = true;
			} else if (this.$route.name == "video") {
				this.active = 3;
				this.show = true;
			} else if (this.$route.name == "choose") {
				this.active = 2;
				this.show = true;
			} else if (this.$route.name == "game") {
				this.active = 1;
				this.show = true;
			} else if (this.$route.name == "mine") {
				this.active = 4;
				this.show = true;
			} else {
				this.show = false;
			}
		},
	};
</script>

<style lang="less" scoped>
	@tabbar-height: 110px;
	@accent: #f07178;

	.app-tabbar.van-tabbar {
		height: @tabbar-height;
		background: #fff !important;
		box-shadow: 0 -8px 28px rgba(240, 113, 120, 0.14);
		overflow: visible !important;
		padding-bottom: constant(safe-area-inset-bottom);
		padding-bottom: env(safe-area-inset-bottom);
	}

	/deep/ .van-tabbar-item {
		font-size: 22px;
		color: @accent !important;
		background: transparent;
	}

	/deep/ .van-tabbar-item--active {
		color: @accent !important;
		background: transparent !important;
	}

	/deep/ .van-tabbar-item__text {
		font-size: 22px;
		line-height: 1.2;
		margin-top: 2px;
	}

	/deep/ .van-tabbar-item__icon {
		margin-bottom: 4px;
	}

	/deep/ .van-tabbar-item__icon img {
		height: 7.2vw;
		width: auto;
		display: block;
	}

	/* 中间凸起圆形按钮 */
	/deep/ .tab-center {
		overflow: visible !important;

		.van-tabbar-item__icon {
			height: auto !important;
			margin-bottom: 0;
		}

		.van-tabbar-item__icon img.tui,
		.van-tabbar-item__icon img {
			width: 96px !important;
			height: 96px !important;
			margin-top: -42px;
			padding: 18px;
			box-sizing: border-box;
			object-fit: contain;
			border-radius: 50%;
			background: linear-gradient(165deg, #c9b8f5 0%, #e0b4e8 45%, #f2c4d8 100%);
			box-shadow:
				0 0 0 10px #fff,
				0 10px 28px rgba(180, 150, 220, 0.35),
				0 4px 12px rgba(210, 160, 200, 0.2);
			z-index: 10;
		}

		.van-tabbar-item__text {
			position: relative;
			z-index: 1;
		}
	}

	[class*="van-hairline"]::after {
		border: none !important;
	}
</style>
